import React from "react";
import store from "store";
import $ from "jquery";
import Page from "../Page";
import {
  QueryParam,
  API_PROFILE,
  API_QUIZ_BASE_URL,
  CheckAuth,
  BASE_URL,
} from "../Util";
import {
  Row,
  Col,
  ProgressBar,
  Input,
  Pagination,
  Button,
  Icon,
  Modal,
} from "react-materialize";
import Notifications, { notify } from "react-notify-toast";
import { Redirect } from "react-router-dom";
import { Link } from "react-router-dom";
import Image from "../Image";
import QuizHeader from "./Header";

class QuizAttempt extends Page {
  constructor(props) {
    super(props);
    this.state = {
      data: null,
      uuid: props.match.params.uuid,
      answers: {},
      submitted: false,
    };
  }

  componentDidMount() {
    $(".btn-help").hide();
    this.handleLoadData();
  }

  handleLoadData = (e) => {
    // remove result
    for (var key in localStorage) {
      if (key && key.startsWith("result_")) {
        store.remove(key);
        console.log("remove old result", key);
      }
      if (key && key.startsWith("quiz_")) {
        if (key != "quiz_" + this.state.uuid) {
          store.remove(key);
          console.log("remove other session", key);
        }
      }
    }
    // store.remove(`result_${this.state.uuid}`);

    $.get(API_QUIZ_BASE_URL + this.state.uuid).then((data) => {
      let quizData = this.getQuizSession();

      if (quizData) {
        this.setState(quizData);
      } else {
        this.setState({
          data: data.payload,
          question: data.payload.questions[0],
          number: 1,
        });
        this.saveQuizSession();
      }
    });
  };

  handleConfirmSubmit = (e) => {
    e.preventDefault();
    $("#submit-btn").trigger("click");
  };

  handleSubmitQuiz = (e) => {
    $.post(API_QUIZ_BASE_URL + this.state.uuid, {
      answers: JSON.stringify(this.state.answers),
    }).then((data) => {
      const payload = data.payload;
      store.remove(`quiz_${this.state.uuid}`);

      // temporary not save result
      // store.set(`result_${this.state.uuid}`, payload);

      if (payload.is_last_chapter && payload.is_passed) {
        store.set(`completed_${payload.course_uuid}`, true);
        store.set("review_modul", payload.course_uuid);
      }

      this.props.history.push("/quiz/result/" + this.state.uuid);
      // this.setState({ submitted: true });
    });
  };

  handleSelectQuestion = (page) => {
    this.setState({ question: this.state.data.questions[page - 1] });
  };

  handleNextQuestion = (e) => {
    if (this.state.question.order == this.state.data.questions.length - 1) {
      this.handleConfirmSubmit(e);
    } else {
      this.setState({
        question: this.state.data.questions[this.state.question.order + 1],
      });
      super.scrollToTop();
    }
    e.preventDefault();
  };

  handlePreviousQuestion = () => {
    this.setState({
      question: this.state.data.questions[this.state.question.order - 1],
    });
    super.scrollToTop();
  };

  handleSelectAnswer = (e) => {
    let questionUuid = this.state.question.uuid;
    let answers = this.state.answers;
    let single_type =
      this.state.question.type && this.state.question.type === "single";
    if (single_type) {
      answers[questionUuid] = e.target.value;
    } else {
      const existing = answers[questionUuid] || [];
      const index = existing.indexOf(e.target.value);
      if (index > -1) {
        existing.splice(index, 1);
      } else {
        existing.push(e.target.value);
      }
      answers[questionUuid] = existing;
    }
    this.setState({ answers: answers });
    this.saveQuizSession();
  };

  saveQuizSession = () => {
    store.set(`quiz_${this.state.uuid}`, this.state);
  };

  getQuizSession = () => {
    return store.get(`quiz_${this.state.uuid}`);
  };

  render() {
    let data = this.state.data;
    let question = this.state.question;

    if (!data) {
      return super.render();
    }

    if (this.state.submitted) {
      return <Redirect to={"/quiz/result/" + data.uuid} />;
    }

    return (
      <div className="bg-white fullheight">
        <QuizHeader data={data} />
        <form onSubmit={this.handleNextQuestion.bind(this)} className="pad-ml">
          <div className="container mt-m mb-m">
            <h5 className="font-orange">
              Pertanyaan {question.order + 1}{" "}
              <span className="font-grey">dari {data.questions.length}</span>
            </h5>
            <div className="font-grey">
              {question.type == "single"
                ? "Pilih satu jawaban benar"
                : "Pilih lebih dari satu jawaban benar"}{" "}
            </div>
            <h5 className="question-content">
              <p dangerouslySetInnerHTML={{ __html: question.content }} />
            </h5>

            <div className="answers">
              {question.answers &&
                question.answers.map((answer, i) => (
                  <p className="" key={`options-${i}`}>
                    {question.type == "single" && (
                      <Input
                        required
                        onClick={this.handleSelectAnswer}
                        name="answer"
                        type="radio"
                        value={answer.uuid}
                        label={answer.content}
                        checked={
                          this.state.answers[question.uuid] == answer.uuid
                        }
                      />
                    )}
                    {question.type == "multiple" && (
                      <Input
                        {...(!this.state.answers[question.uuid]
                          ? { requred: true }
                          : null)}
                        onClick={this.handleSelectAnswer}
                        name="answer"
                        type="checkbox"
                        value={answer.uuid}
                        label={answer.content}
                        checked={
                          (this.state.answers[question.uuid] || []).indexOf(
                            answer.uuid.toString()
                          ) != -1
                        }
                      />
                    )}
                  </p>
                ))}
              <div>&nbsp;</div>
            </div>
            <Pagination
              className="center hide"
              onSelect={this.handleSelectQuestion}
              items={data.questions.length}
              activePage={question.order + 1}
              maxButtons={data.questions.length}
            />

            <div className="footer-fixed bg-grey pad-ml">
              <div className="container">
                {question.order > 0 && (
                  <a
                    onClick={this.handlePreviousQuestion.bind(this)}
                    className="btn left btn-outline"
                  >
                    SEBELUMNYA
                  </a>
                )}
                {question.order < data.questions.length - 1 && (
                  <Button className="right">LANJUT</Button>
                )}
                {question.order == data.questions.length - 1 && (
                  <Button className="right">SUBMIT</Button>
                )}
              </div>
            </div>
            <Modal
              trigger={
                <Button id="submit-btn" className="right hide">
                  SUBMIT
                </Button>
              }
            >
              <h5>Submit Jawaban</h5>
              <p>
                Apakah Anda yakin ingin mengirim jawaban?
                <br />
                Periksa kembali jawaban Anda sebelum dikirim
              </p>
              <div className="mt-m">
                <a className="btn modal-close btn-outline">BATAL</a>
                <a
                  onClick={this.handleSubmitQuiz.bind(this)}
                  className="btn modal-close right"
                >
                  KIRIM
                </a>
              </div>
            </Modal>
            <br />
            <br />
          </div>
        </form>
      </div>
    );
  }
}

export default QuizAttempt;



// WEBPACK FOOTER //
// ./src/components/Quiz/Attempt.js